const userAgent = navigator.wxuserAgent || navigator.userAgent;

/**
 * 获取OS信息
 */
export function getOSInfoObj() {
  let pattern = /iPhone OS ([\d_]+)/i;
  let wc = userAgent.match(pattern);
  if (wc) return { type: 'iphone', version: wc[1].replace('_', '.') };
  pattern = /Android ([\d.]+)/i;
  wc = userAgent.match(pattern);
  if (wc) return { type: 'android', version: wc[1] };
  return { type: 'none', version: '0.0.0' };
}

export function getOSInfoText(){
  let os = getOSInfoObj();
  return `${os.type} ${os.version}`;
}

/**
 * 获取微信版本
 */
export function getWeixinVer() {
  // ...MicroMessenger/7.0.1380(0x2700003D)...获取(0x....)
  let pattern = /MicroMessenger\/[\d.]+\((.*)\)/i;
  let wc = userAgent.match(pattern);
  if (!wc) {
    pattern = /MicroMessenger\/([\d.]+)/i;
    wc = userAgent.match(pattern);
    if (wc) return wc[1];
  }
  if (!wc) return '0.0.0';
  const version = wc[1].slice(3);
  const result = [];
  result.push(parseInt(version.slice(0, 1), 16));
  result.push(parseInt(version.slice(1, 3), 16));
  result.push(parseInt(version.slice(3, 5), 16));
  return result.join('.') || '0.0.0';
}